module.exports = {"id":"dp5_2l1q4","text":"Identifying Needs and Digital Technological Responses","instructions":"How often do you adjust settings like text size, volume or contrast to suit your needs?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.2","questionType":"Scale","random":false,"options":[{"id":"dp5_2l1q4-a1","text":"Never","score":0},{"id":"dp5_2l1q4-a2","text":"Rarely","score":0.4},{"id":"dp5_2l1q4-a3","text":"Sometimes","score":1},{"id":"dp5_2l1q4-a4","text":"Often","score":1.6},{"id":"dp5_2l1q4-a5","text":"Very often","score":2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.2/l1q4.json
// module id = 1305
// module chunks = 41